import { ApiRx } from "@polkadot/api";
import { authenticateStepV1 as wrappedAuthenticateStepV1 } from "../wrappers";
import { StepRetrySchema } from "./errorData";
import processRpcCall, { specialErrorPagesMapFn } from "./processRpcCall";

export type AuthenticateStepV1Response = Awaited<
  ReturnType<typeof authenticateStepV1>
>;

const errorMessageToSpecialErrorPage = {
  "server error: person not found": "personNotFound",
  "server error: signature invalid": "signatureInvalid",
  "validator key not available": "validatorKeyNotAvailable",
} as const;

const authenticateStepV1 = async (
  api: ApiRx,
  requestBlob: string,
  context?: string,
) =>
  processRpcCall(
    () => wrappedAuthenticateStepV1(api, requestBlob, context),
    StepRetrySchema,
    specialErrorPagesMapFn(errorMessageToSpecialErrorPage),
  );

export default authenticateStepV1;
